import { Link } from "react-router-dom";
import { socialLinks } from "@/config/social";
import logo from "@/assets/landing/yoluno-logo-original.png";

const footerLinks = [
  { label: "Features", to: "/features" },
  { label: "For Parents", to: "/for-parents" },
  { label: "Pricing", to: "/pricing" },
  { label: "About", to: "/about" },
  { label: "Watch", to: "/watch" },
  { label: "Blog", to: "/blog" },
  { label: "FAQs", to: "/faqs" },
];


export default function Footer() {
  return (
    <footer className="bg-secondary border-t border-border pt-16 pb-10 px-6">
      <div className="container flex flex-col items-center gap-8">
        <img src={logo} alt="Yoluno" className="h-14" />

        <nav className="flex flex-wrap justify-center gap-6">
          {footerLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="text-sm font-body text-muted-foreground hover:text-foreground transition-colors"
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <p className="text-center font-body text-muted-foreground text-sm">
          Where Curiosity, Creativity & Care Come Together 🌱
        </p>

        <nav aria-label="Yoluno on social media" className="flex items-center gap-3">
          {socialLinks.map(({ label, href, Icon }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Yoluno on ${label}`}
              className="grid place-items-center w-11 h-11 rounded-full border border-border bg-card text-muted-foreground hover:text-primary hover:border-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 transition-colors"
            >
              <Icon className="w-5 h-5" />
            </a>
          ))}
        </nav>

        <p className="text-center font-body text-muted-foreground/70 text-xs">
          © 2026 Yoluno. Made with 💛 for children everywhere.
        </p>
        <div className="flex flex-wrap justify-center gap-3 mt-3">
          <Link to="/privacy-policy" className="font-body text-muted-foreground/70 hover:text-foreground text-xs transition-colors">Privacy Policy</Link>
          <span className="text-border text-xs">·</span>
          <a href="/safety-charter" className="font-body text-muted-foreground/70 hover:text-foreground text-xs transition-colors">Safety Charter</a>
          <span className="text-border text-xs">·</span>
          <Link to="/data-practices" className="font-body text-muted-foreground/70 hover:text-foreground text-xs transition-colors">Data Practices</Link>
          <span className="text-border text-xs">·</span>
          <Link to="/how-ai-works" className="font-body text-muted-foreground/70 hover:text-foreground text-xs transition-colors">How Yoluno Works</Link>
        </div>
      </div>
    </footer>
  );
}
